import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadGroupConfidentialityDeedByGroupId: IGroupConfidentialityDeedLoadByGroupIdActionCreator = (groupId) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_GROUP_ID,
            groupId
        }
    },
    LoadGroupConfidentialityDeedById: IGroupConfidentialityDeedLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IGroupConfidentialityDeedLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IGroupConfidentialityDeedLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveGroupConfidentialityDeed: IGroupConfidentialityDeedSaveActionCreator = (formData) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_SAVE,
            formData
        }
    },
    SaveSuccess: IGroupConfidentialityDeedSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IGroupConfidentialityDeedSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateGroupConfidentialityDeed: IGroupConfidentialityDeedValidateActionCreator = (formData) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IGroupConfidentialityDeedValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IGroupConfidentialityDeedValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateGroupConfidentialityDeed: IGroupConfidentialityDeedCreateActionCreator = (groupId) => {

        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_CREATE,
            groupId
        }
    },
    CreateSuccess: IGroupConfidentialityDeedCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IGroupConfidentialityDeedCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteGroupConfidentialityDeed: IGroupConfidentialityDeedDeleteActionCreator = (id) => {
        
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_DELETE,
            id
        }
    },
    DeleteSuccess: IGroupConfidentialityDeedDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_DELETE_SUCCESS,
        }
    },
    DeleteFailure: IGroupConfidentialityDeedDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_DELETE_FAILURE,
            responseStatus
        }
    },

    SyncGroupConfidentialityDeed: IGroupConfidentialityDeedSyncActionCreator = (groupId) => {

        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_SYNC,
            groupId
        }
    },
    SyncSuccess: IGroupConfidentialityDeedSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: IGroupConfidentialityDeedSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: IGroupConfidentialityDeedClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_CLEAR,
            propertiesToClear
        }
    },

    Filter: IGroupConfidentialityDeedFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_GROUPCONFIDENTIALITYDEED_FILTER,
            formFilter
        }
    };



export const
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_GROUP_ID = "ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_GROUP_ID",
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_ID = "ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_ID",
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_SUCCESS = "ACTION_GROUPCONFIDENTIALITYDEED_LOAD_SUCCESS",
    ACTION_GROUPCONFIDENTIALITYDEED_LOAD_FAILURE = "ACTION_GROUPCONFIDENTIALITYDEED_LOAD_FAILURE",

    ACTION_GROUPCONFIDENTIALITYDEED_SAVE = "ACTION_GROUPCONFIDENTIALITYDEED_SAVE",
    ACTION_GROUPCONFIDENTIALITYDEED_SAVE_SUCCESS = "ACTION_GROUPCONFIDENTIALITYDEED_SAVE_SUCCESS",
    ACTION_GROUPCONFIDENTIALITYDEED_SAVE_FAILURE = "ACTION_GROUPCONFIDENTIALITYDEED_SAVE_FAILURE",

    ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE = "ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE",
    ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_SUCCESS = "ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_SUCCESS",
    ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_FAILURE = "ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_FAILURE",

    ACTION_GROUPCONFIDENTIALITYDEED_CREATE = "ACTION_GROUPCONFIDENTIALITYDEED_CREATE",
    ACTION_GROUPCONFIDENTIALITYDEED_CREATE_SUCCESS = "ACTION_GROUPCONFIDENTIALITYDEED_CREATE_SUCCESS",
    ACTION_GROUPCONFIDENTIALITYDEED_CREATE_FAILURE = "ACTION_GROUPCONFIDENTIALITYDEED_CREATE_FAILURE",

    ACTION_GROUPCONFIDENTIALITYDEED_DELETE = "ACTION_GROUPCONFIDENTIALITYDEED_DELETE",
    ACTION_GROUPCONFIDENTIALITYDEED_DELETE_SUCCESS = "ACTION_GROUPCONFIDENTIALITYDEED_DELETE_SUCCESS",
    ACTION_GROUPCONFIDENTIALITYDEED_DELETE_FAILURE = "ACTION_GROUPCONFIDENTIALITYDEED_DELETE_FAILURE",

    ACTION_GROUPCONFIDENTIALITYDEED_SYNC = "ACTION_GROUPCONFIDENTIALITYDEED_SYNC",
    ACTION_GROUPCONFIDENTIALITYDEED_SYNC_SUCCESS = "ACTION_GROUPCONFIDENTIALITYDEED_SYNC_SUCCESS",
    ACTION_GROUPCONFIDENTIALITYDEED_SYNC_FAILURE = "ACTION_GROUPCONFIDENTIALITYDEED_SYNC_FAILURE",

    ACTION_GROUPCONFIDENTIALITYDEED_CLEAR = "ACTION_GROUPCONFIDENTIALITYDEED_CLEAR",

    ACTION_GROUPCONFIDENTIALITYDEED_FILTER = "ACTION_GROUPCONFIDENTIALITYDEED_FILTER";

export interface IGroupConfidentialityDeedLoadByGroupIdAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_GROUP_ID";
    groupId: number;
}

export interface IGroupConfidentialityDeedLoadByGroupIdActionCreator {
    (groupId: number): IGroupConfidentialityDeedLoadByGroupIdAction;
}

export interface IGroupConfidentialityDeedLoadSuccessAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_LOAD_SUCCESS";
    formData: Dtos.GroupConfidentialityDeed | Dtos.GroupConfidentialityDeed[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupConfidentialityDeedLoadSuccessActionCreator {
    (
        formData: Dtos.GroupConfidentialityDeed | Dtos.GroupConfidentialityDeed[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IGroupConfidentialityDeedLoadSuccessAction;
}

export interface IGroupConfidentialityDeedLoadFailureAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupConfidentialityDeedLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedLoadFailureAction;
}

export interface IGroupConfidentialityDeedLoadByIdAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_LOAD_BY_ID";
    id: number;
}

export interface IGroupConfidentialityDeedLoadByIdActionCreator {
    (id: number): IGroupConfidentialityDeedLoadByIdAction;
}

export interface IGroupConfidentialityDeedSaveAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_SAVE";
    formData: Dtos.GroupConfidentialityDeed;

}

export interface IGroupConfidentialityDeedSaveActionCreator {
    (
        formData: Dtos.GroupConfidentialityDeed
    ): IGroupConfidentialityDeedSaveAction;
}

export interface IGroupConfidentialityDeedSaveSuccessAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_SAVE_SUCCESS";
    formData: Dtos.GroupConfidentialityDeed;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupConfidentialityDeedSaveSuccessActionCreator {
    (
        formData: Dtos.GroupConfidentialityDeed,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupConfidentialityDeedSaveSuccessAction;
}

export interface IGroupConfidentialityDeedSaveFailureAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupConfidentialityDeedSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedSaveFailureAction;
}

export interface IGroupConfidentialityDeedValidateAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE";
    formData: Dtos.GroupConfidentialityDeed;

}

export interface IGroupConfidentialityDeedValidateActionCreator {
    (
        formData: Dtos.GroupConfidentialityDeed
    ): IGroupConfidentialityDeedValidateAction;
}

export interface IGroupConfidentialityDeedValidateSuccessAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_SUCCESS";
    formData: Dtos.GroupConfidentialityDeed;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupConfidentialityDeedValidateSuccessActionCreator {
    (
        formData: Dtos.GroupConfidentialityDeed,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupConfidentialityDeedValidateSuccessAction;
}

export interface IGroupConfidentialityDeedValidateFailureAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupConfidentialityDeedValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedValidateFailureAction;
}

export interface IGroupConfidentialityDeedCreateAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_CREATE",
    groupId: number
}

export interface IGroupConfidentialityDeedCreateActionCreator {
    (groupId: number): IGroupConfidentialityDeedCreateAction
}

export interface IGroupConfidentialityDeedCreateSuccessAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_CREATE_SUCCESS";
    formData: Dtos.GroupConfidentialityDeed;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IGroupConfidentialityDeedCreateSuccessActionCreator {
    (
        formData: Dtos.GroupConfidentialityDeed,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IGroupConfidentialityDeedCreateSuccessAction;
}

export interface IGroupConfidentialityDeedCreateFailureAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupConfidentialityDeedCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedCreateFailureAction;
}

export interface IGroupConfidentialityDeedDeleteAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_DELETE";
    id: number;
}

export interface IGroupConfidentialityDeedDeleteActionCreator {
    (id: number): IGroupConfidentialityDeedDeleteAction
}

export interface IGroupConfidentialityDeedDeleteSuccessAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_DELETE_SUCCESS";
}

export interface IGroupConfidentialityDeedDeleteSuccessActionCreator {
    (): IGroupConfidentialityDeedDeleteSuccessAction;
}

export interface IGroupConfidentialityDeedDeleteFailureAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupConfidentialityDeedDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedDeleteFailureAction;
}

export interface IGroupConfidentialityDeedClearAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_CLEAR";
    propertiesToClear?: string[];
}

export interface IGroupConfidentialityDeedClearActionCreator {
    (propertiesToClear?: string[]): IGroupConfidentialityDeedClearAction;
}

export interface IGroupConfidentialityDeedFilterActionCreator {
    (formFilter: IFormFilter): IGroupConfidentialityDeedFilterAction;
}

export interface IGroupConfidentialityDeedFilterAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_FILTER";
    formFilter: IFormFilter;
}

export interface IGroupConfidentialityDeedSyncAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_SYNC",
    groupId: number
}

export interface IGroupConfidentialityDeedSyncActionCreator {
    (groupId: number): IGroupConfidentialityDeedSyncAction
}

export interface IGroupConfidentialityDeedSyncSuccessAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_SYNC_SUCCESS";
    formData: Dtos.GroupConfidentialityDeed[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupConfidentialityDeedSyncSuccessActionCreator {
    (
        formData: Dtos.GroupConfidentialityDeed[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IGroupConfidentialityDeedSyncSuccessAction;
}

export interface IGroupConfidentialityDeedSyncFailureAction {
    type: "ACTION_GROUPCONFIDENTIALITYDEED_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupConfidentialityDeedSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupConfidentialityDeedSyncFailureAction;
}

export type GroupConfidentialityDeedAction =
    IGroupConfidentialityDeedLoadByGroupIdAction |
    IGroupConfidentialityDeedLoadByIdAction |
    IGroupConfidentialityDeedLoadFailureAction |
    IGroupConfidentialityDeedLoadSuccessAction |
    IGroupConfidentialityDeedSaveAction |
    IGroupConfidentialityDeedSaveSuccessAction |
    IGroupConfidentialityDeedSaveFailureAction |
    IGroupConfidentialityDeedValidateAction |
    IGroupConfidentialityDeedValidateSuccessAction |
    IGroupConfidentialityDeedValidateFailureAction |
    IGroupConfidentialityDeedCreateAction |
    IGroupConfidentialityDeedCreateSuccessAction |
    IGroupConfidentialityDeedCreateFailureAction |
    IGroupConfidentialityDeedDeleteAction |
    IGroupConfidentialityDeedDeleteSuccessAction |
    IGroupConfidentialityDeedDeleteFailureAction |
    IGroupConfidentialityDeedSyncAction |
    IGroupConfidentialityDeedSyncSuccessAction |
    IGroupConfidentialityDeedSyncFailureAction |
    IGroupConfidentialityDeedClearAction | 
    IGroupConfidentialityDeedFilterAction;
